// Copyright (c) 2016 Deere & Company

import './input-field.scss';
import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

function handleInputChange(event) {

    this.onInputChange(event.target.value);

}

const InputField = props =>
    <div className='inputBox'>
        <span className='data-label asterisk-after'>
            <FormattedMessage id={props.label}/>
        </span>
        <input
            onChange={props::handleInputChange}
            type='text'
        />
    </div>;

InputField.displayName = 'InputField';
InputField.propTypes = {
    label: PropTypes.string.isRequired,
    onInputChange: PropTypes.func.isRequired,
    propertyToUpdate: PropTypes.string.isRequired
};

export default InputField;



// WEBPACK FOOTER //
// ./src/product/transfers/components/input-field.js